export class PortalUserInfo {

    RegisterTypeId: number;
    PortalUserTypeId :number;
    PreferedServiceId:number;
    FullName :string;
    Address :string;
    CountryId :number;
    Mobile:string;
    Fax :string;
    Organization: string;
    Email: string;
};